import type { Mixin } from "./define-component.js";

// withShadow attached die ShadowRoot in connectedCallback (idempotent
// gegen Re-Connects). Die Shadow-Root wird im ComponentContext geteilt.
export function withShadow(opts: ShadowRootInit = { mode: "open" }): Mixin {
  return (host, ctx) => ({
    connect() {
      if (!ctx.shadowRoot) {
        ctx.shadowRoot = host.attachShadow(opts);
      } else {
        // Reconnect: render() läuft bei JEDEM connect (defineComponent). Wird ein WC
        // im DOM bewegt (disconnect+reconnect, z.B. ein eingebettetes Kind, das sein
        // Parent umhängt), würde ein append-basiertes render() (die Mehrheit der WCs)
        // seinen Shadow-Inhalt anhäufen. Darum den Shadow vor dem Re-Render leeren.
        // Betrifft nur withShadow-WCs (client-gerendert); DSD/SSR-Shells nutzen
        // withDeclarativeShadow und bleiben unberührt. PFS-666.
        ctx.shadowRoot.replaceChildren();
      }
    },
  });
}
